import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const ArsisPieChart = ({ labels, data, pvqSortArray, setPvqHover }) => {
  const options = {
    responsive: true,
    spanGaps: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
        titleFontFamily: 'IRANYekanX',

        external: function (context) {
          const tooltipModel = context.tooltip;
          const { dataPoints } = tooltipModel || {};
          const sliceKey = dataPoints && dataPoints[0]?.label;
          const dataIndex = dataPoints && dataPoints[0]?.dataIndex;
          const position = context.chart.canvas.getBoundingClientRect();

          let tooltipEl = document.getElementById('chartjs-tooltip');

          const findPvq = pvqSortArray && pvqSortArray.find((i) => i.key === sliceKey);
          const { persist, key, label } = findPvq || {};

          setPvqHover?.(key);

          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.innerHTML = '<table></table>';
            document.body.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            setPvqHover?.(0);
            return;
          }

          function getBody(bodyItem) {
            return bodyItem.lines;
          }

          if (tooltipModel.body) {
            const bodyLines = tooltipModel.body.map(getBody);
            let innerHtml = '<thead>';
            const index = setPvqHover ? `%${persist}` : '';
            const title = setPvqHover ? label : sliceKey;
            innerHtml += '</thead><tbody>';
            bodyLines.forEach(function (body, i) {
              const colors = tooltipModel.labelColors[i];
              let styles = 'background: #fff';
              styles += `; border-color:${colors.borderColor}`;
              styles += '; border-width: 2px';
              styles += '; padding: 6px';
              styles += '; border-radius: 6px';
              styles += '; box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2)';
              const pvqSpan = '<span style="' + styles + '">' + index + ' ' + title + '</span>';

              innerHtml += `<tr><td>${pvqSpan}</td></tr>`;
            });
            innerHtml += '</tbody>';

            const tableRoot = tooltipEl.querySelector('table');
            tableRoot.innerHTML = innerHtml;
          }

          const calcLeft = position.left + window.pageXOffset + tooltipModel.caretX;

          const leftValue =
            dataIndex === 0 ? calcLeft - 10 : dataIndex === 10 ? calcLeft - 100 : calcLeft - 60;

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.position = 'absolute';
          tooltipEl.style.left = `${Math.ceil(leftValue)}px`;
          tooltipEl.style.top = `${position.top + window.pageYOffset + tooltipModel.caretY - 40}px`;
          tooltipEl.style.padding = `${tooltipModel.padding}px ${tooltipModel.padding}px`;
          tooltipEl.style.pointerEvents = 'none';
        },
      },
      title: {
        display: false,
      },
    },
  };

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '',
        data: data,
        backgroundColor: [
          '#FFA07A', // Light Salmon
          '#EEE8AA', // Pale Goldenrod
          '#90EE90', // Light Green
          '#66CDAA', // Medium Aquamarine
          '#87CEFA', // Light Sky Blue
          '#DDA0DD', // Plum
          '#FFB6C1', // Light Pink
          '#F08080', // Light Coral (Red)
          '#E6E6FA', // Lavender
          '#B0C4DE', // Light Steel Blue
        ],
        hoverBackgroundColor: [
          '#FA8072', // Salmon (Darker for Light Salmon)
          '#FFD700', // Gold (Darker for Pale Goldenrod)
          '#32CD32', // Lime Green (Darker for Light Green)
          '#2E8B57', // Sea Green (Darker for Medium Aquamarine)
          '#1E90FF', // Dodger Blue (Darker for Light Sky Blue)
          '#8B008B', // Dark Magenta (Darker for Plum)
          '#FF1493', // Deep Pink (Darker for Light Pink)
          '#DC143C', // Crimson (Darker for Light Coral)
          '#9370DB', // Medium Purple (Darker for Lavender)
          '#4682B4', // Steel Blue (Darker for Light Steel Blue)
        ],
        hoverBorderColor: 'rgba(0, 0, 0, 0)',
        hoverOffset: 4,
        family: 'IRANYekanX',
      },
    ],
  };

  return <Pie data={chartData} options={options} />;
};

export default ArsisPieChart;
